module.exports = __webpack_public_path__ + "img/collectiongallery_hearts.00cf7fe.webp";